import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DownloadIcon from '@mui/icons-material/Download';
import SnackbarAlert from '../../../components/SnackbarAlert';
import { downloadRelatorioPLFundos } from '../../../services/relatoriosService';
import { getFundosGerenciados } from '../../../services/fundosGerenciadosService';
import { FundosGerenciadosData } from '../../../types/fundosGerenciados';

const RelatorioPLFundos: React.FC = () => {
  const [fundos, setFundos] = useState<FundosGerenciadosData[]>([]);
  const [selectedFundo, setSelectedFundo] = useState<number | ''>('');
  const [loading, setLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    message: '',
    severity: 'success' as 'success' | 'error',
  });

  useEffect(() => {
    getFundosGerenciados().then(setFundos).catch(() => {});
  }, []);

  const handleDownload = async () => {
    if (!selectedFundo) return;
    setLoading(true);
    try {
      await downloadRelatorioPLFundos(selectedFundo);
      setSnackbarProps({ open: true, message: 'Relatório gerado com sucesso!', severity: 'success' });
    } catch {
      setSnackbarProps({ open: true, message: 'Erro ao gerar relatório.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Relatório - Patrimônio Líquido por Fundo</h2>
      <p style={{ color: '#555', marginBottom: '24px' }}>
        Selecione um fundo para baixar o histórico completo de Patrimônio Líquido em Excel.
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 320 }}>
          <InputLabel>Fundo</InputLabel>
          <Select
            value={selectedFundo}
            onChange={(e) => setSelectedFundo(e.target.value as number)}
            label="Fundo"
          >
            {fundos.map((f) => (
              <MenuItem key={f.id} value={f.id}>{f.fantasia}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />}
          onClick={handleDownload}
          disabled={loading || !selectedFundo}
        >
          {loading ? 'Gerando...' : 'Baixar Excel'}
        </Button>
      </div>
      <SnackbarAlert
        open={snackbarProps.open}
        message={snackbarProps.message}
        severity={snackbarProps.severity}
        onClose={() => setSnackbarProps({ ...snackbarProps, open: false })}
      />
    </div>
  );
};

export default RelatorioPLFundos;
